// extracted by mini-css-extract-plugin
module.exports = {"logo2":"dh-vbm-logo2","intro__content--optimize":"dh-vbm-intro__content--optimize","logo2__image":"dh-vbm-logo2__image","pulse":"dh-vbm-pulse"};